

export default umdIntro;
import { globalify, req } from 'utils/mappers';
import processName from '../amd/processName';
import processIds from '../amd/processIds';
import getImportSummary from '../amd/getImportSummary';
function umdIntro(_ref) {
	var amdName = _ref.amdName;
	var name = _ref.name;
	var hasExports = _ref.hasExports;
	var imports = _ref.imports;
	var absolutePaths = _ref.absolutePaths;
	var externalDefaults = _ref.externalDefaults;
	var indentStr = _ref.indentStr;
	var strict = _ref.strict;
	var useStrict = _ref.useStrict;

	var useStrictPragma = useStrict ? ' \'use strict\';' : '';
	var intro = undefined;

	if (!hasExports && !imports.length) {
		intro = '(function (factory) {\n\t\t\t\t!(typeof exports === \'object\' && typeof module !== \'undefined\') &&\n\t\t\t\ttypeof define === \'function\' && define.amd ? define(' + processName(amdName) + 'factory) :\n\t\t\t\tfactory()\n\t\t\t}(function () {' + useStrictPragma + '\n\n\t\t\t';
	} else {
		var _getImportSummary = getImportSummary({ imports: imports, name: amdName, absolutePaths: absolutePaths });

		var ids = _getImportSummary.ids;
		var paths = _getImportSummary.paths;
		var names = _getImportSummary.names;

		var amdExport = undefined,
		    cjsExport = undefined,
		    globalExport = undefined,
		    defaultsBlock = undefined;

		if (strict) {
			cjsExport = 'factory(' + (hasExports ? ['exports'] : []).concat(paths.map(req)).join(', ') + ')';
			var globalDeps = (hasExports ? ['(global.' + name + ' = {})'] : []).concat(names.map(globalify)).join(', ');
			globalExport = 'factory(' + globalDeps + ')';

			if (hasExports) {
				ids.unshift('exports');
				names.unshift('exports');
			}

			amdExport = 'define(' + processName(amdName) + processIds(ids) + 'factory)';
			defaultsBlock = '';
			if (externalDefaults && externalDefaults.length > 0) {
				defaultsBlock = externalDefaults.map(function (x) {
					return '\t' + (x.needsNamed ? 'var ' + x.name + '__default' : x.name) + (' = (\'default\' in ' + x.name + ' ? ' + x.name + '[\'default\'] : ' + x.name + ');');
				}).join('\n') + '\n\n';
			}
		} else {
			amdExport = 'define(' + processName(amdName) + processIds(ids) + 'factory)';
			cjsExport = (hasExports ? 'module.exports = ' : '') + ('factory(' + paths.map(req).join(', ') + ')');
			globalExport = (hasExports ? 'global.' + name + ' = ' : '') + ('factory(' + names.map(globalify).join(', ') + ')');

			defaultsBlock = '';
		}

		intro = '(function (global, factory) {\n\t\t\t\ttypeof exports === \'object\' && typeof module !== \'undefined\' ? ' + cjsExport + ' :\n\t\t\t\ttypeof define === \'function\' && define.amd ? ' + amdExport + ' :\n\t\t\t\t' + globalExport + '\n\t\t\t}(this, function (' + names.join(', ') + ') {' + useStrictPragma + '\n\n\t\t\t' + defaultsBlock;
	}

	return intro.replace(/^\t\t\t/gm, '').replace(/\t/g, indentStr);
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/umd/umdIntro.js.01-babel.map